import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard } from "lucide-react";

/**
 * Floating "Back to dashboard" pill shown to restaurant owners
 * whenever they are browsing customer-facing pages. Avoids the
 * impression of being logged out when exploring the public site.
 */
export default function BackToDashboardPill() {
  const { profile, user } = useAuth();
  const location = useLocation();

  if (!user || !profile?.is_restaurant_owner) return null;

  const path = location.pathname;
  const hideOn =
    path.startsWith("/dashboard") ||
    path.startsWith("/admin") ||
    path.startsWith("/auth") ||
    path === "/";

  if (hideOn) return null;

  return (
    <Link
      to="/dashboard/hub"
      aria-label="Zurück zum Restaurant-Dashboard"
      style={{ bottom: "calc(env(safe-area-inset-bottom) + 88px)" }}
      className="fixed left-4 sm:bottom-6 z-[9998] flex items-center gap-2 px-3.5 h-11 rounded-full bg-primary text-primary-foreground font-bold shadow-2xl border-2 border-background hover:scale-105 active:scale-95 transition-transform"
    >
      <LayoutDashboard className="w-4 h-4" />
      <span className="text-sm">Dashboard</span>
    </Link>
  );
}
